import React, {useEffect} from 'react';
import {Redirect, Route, Switch, useLocation} from 'react-router-dom';
import '../src/style/utils.scss';
import Login from './login/components/Login/Login';
import _Login from './login/_components/Login/_Login';
import Navbar from './common/components/Navbar/Navbar';
import _Navbar from './common/components/Navbar/v2/NavBar';
import SidebarMenu from './common/components/SidebarMenu/SidebarMenu';
import UserList from './home/components/UserList/UserList';
import NewUser from './home/components/NewUser/NewUser';
import ViewUser from './home/components/ViewUser/ViewUser';
import EditUser from './home/components/EditUser/EditUser';
import AdminList from './home/components/AdminList/AdminList';
import NewAdmin from './home/components/NewAdmin/NewAdmin';
import EditAdmin from './home/components/EditAdmin/EditAdmin';
import Home from './home/components/Home/Home';
import AffiliatesList from './attentions/components/AffiliateList/AffiliateList';
import AttentionList from './attentions/components/AttentionList/AttentionList';
import PrivateRoute from './common/components/Router/PrivateRoute';
import {ToastContainer} from 'react-toastify';
import LocationRouter from './common/components/Router/LocationRouter';
import 'react-toastify/dist/ReactToastify.css';
import Config from './home/components/Config/Config';
import ChangePass from './login/components/ChangePass/ChangePass';
import ResetPass from './login/components/ResetPass/ResetPass';
import ResetPassRequest from './login/components/ResetPassRequest/ResetPassRequest';
import _ResetPass from './login/_components/ResetPass/_ResetPass';
import _ResetPassRequest from './login/_components/ResetPassRequest/_ResetPassRequest';
import _ChangePass from './login/_components/ChangePass/_ChangePass';
import {useSelector, useDispatch} from 'react-redux';
import actions from './redux/actions';
import Affiliates from './home/components/Affiliates/Affiliates';
import PlanList from './home/components/PlanList/PlanList';
import MedicalServices from './home/components/MedicalServices/MedicalServices';
import MedicalService from './home/components/MedicalService/MedicalService';
import MedicalServiceList from './home/components/MedicalServiceList/MedicalServiceList';
import CreateAttention from './home/components/CreateAttention/CreateAttention';
import AttentionsList from './home/components/AttentionsList/AttentionsList';
import BulkInsert from './home/components/BulkInsert/BulkInsert';
import AmountList from './home/components/AmountList/AmountList';
import _SidebarMenu from './common/components/SidebarMenu/v2/SideBarMenu';
import Test from './pages/Test';
import _CreateAttention from './pages/CreateAttention/CreateAttention';
import _Home from './home/components/Home/v2/_Home';
import _AttentionsHistory from './pages/AttentionsHistory/AttentionsHistory';
import _Affiliates from './pages/Affiliates/Affiliates';
import _Administrators from './pages/Administrators/Administrators';
import _AmountList from './pages/AmountList/AmountList';
import _Config from './pages/Config/_Config';
import ProviderUsers from './pages/ProviderUsers/ProviderUsers';
import _ChangePassword from "./pages/ChangePassword/_ChangePassword";
import _NewUser from "./home/components/NewUser/v2/_NewUser";
import EditProviderUser from "./pages/ProviderUsers/EditProviderUser";
import Api from "./pages/Api/Api";
import ApiDocumentation from "./pages/Api/Documentation";
import Performance from "./pages/Performance/Performance";

const App = () => {
    const showSidebar = useSelector((state) => state.common.showSidebar);
    const dispatch = useDispatch();
    const location = useLocation();
    useEffect(() => {
        if (!showSidebar && window.innerWidth >= 700) {
            dispatch(actions.common.toggleSideBar());
        }
        // eslint-disable-next-line
    }, []);
    return (
        <LocationRouter
            initialRouting={{
                'provider': '/v1/provider/list',
                'plans': '/v1/plans/list',
                'newMedicalService': '/v1/newMedicalService',
                'medicalServiceList': '/v1/newMedicalService',
                'createAttention': '/createAttention',
                'attentionsList': '/attentionsHistory',
                'admin': '/v1/admin/list',
                'affiliate': '/v1/affiliate/list',
                'performance': '/performance',
                'api': '/api',
                'documentacion': '/documentacion',
                'default': '/login',
            }}
            byPassRoutes={['reset-password', 'recovery-password', 'set-password']}
        >
            <div style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
            {location.pathname.startsWith('/v1') ? <Navbar/> : <_Navbar />}
                <Switch>
                    <Route path="/*">
                        <div className={'v2-background'}>
                            <Route path={'/login'} component={_Login}/>
                            <div className={'password-recovery'}>
                                <Route path={'/reset-password/:token'} component={_ResetPass}/>
                                <Route path={'/set-password/:token'} component={_ResetPass}/>
                                <Route path={'/recovery-password'} component={_ResetPassRequest}/>
                            </div>
                        </div>
                        <Switch>
                            <div className="app-div-background-v2">
                                <ToastContainer autoClose={2000}/>
                                <PrivateRoute validRoles={['*']} path={'/home'} component={_Home}/>
                                <PrivateRoute validRoles={['*']} path={'/'} component={_SidebarMenu} redirect={false}/>
                                <div className={'v2-page-tab-container'}>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/list'} component={UserList}/>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/add'} component={_NewUser}/>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/bulkInsert'} component={BulkInsert}/>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/edit'} component={EditUser}/>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/editUser'} component={EditProviderUser}/>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/view'} component={ViewUser}/>

                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/v1/admin/list'} component={AdminList}/>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/v1/admin/add'} component={NewAdmin}/>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/v1/admin/edit'} component={EditAdmin}/>

                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/affiliate/list'} component={AffiliatesList}/>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/affiliate/attentions'} component={AttentionList}/>
                                    <Route path={'/change_password'} component={_ChangePassword}/>
                                    <Route path={'/affiliates'} component={_Affiliates}/>
                                    <Route path={'/attentionsHistory'} component={_AttentionsHistory}/>
                                    <PrivateRoute path={'/createAttention'} validRoles={['ADMIN', 'PROVIDER_USER', 'PROVIDER_ADMIN']}
                                        component={_CreateAttention} />
                                    <Route path={'/administrators'} component={_Administrators}/>
                                    <Route path={'/amountList'} component={_AmountList}/>
                                    <Route path={'/test'} component={Test}/>
                                    <PrivateRoute exact validRoles={['ADMIN', 'PROVIDER_ADMIN']}
                                        path={'/providerUsers'} component={ProviderUsers}/>
                                    <Route path={'/config'} component={_Config}/>
                                    <PrivateRoute exact validRoles={['ADMIN']} path={'/performance'} component={Performance}/>
                                    <PrivateRoute exact validRoles={['DEVELOPER']} path={'/api'} component={Api}/>
                                    <PrivateRoute exact validRoles={['ADMIN', 'DEVELOPER']}
                                        path={['/documentacion', '/documentación']} component={ApiDocumentation}/>
                                </div>
                            </div>
                        </Switch>
                    </Route>
            {/* THIS WAS THE OLDER VERSION:

            <div className="ap-div-background">
                    <ToastContainer autoClose={2000} />
                    <Route path={'/login'} component={Login}/>
                    <PrivateRoute validRoles={['*']} path={'/'} component={SidebarMenu} redirect={false} />
                    <Route path={'/reset-password/:token'} component={ResetPass}/>
                    <Route path={'/set-password/:token'} component={ResetPass}/>
                    <Route path={'/recovery-password'} component={ResetPassRequest}/>

                    <PrivateRoute validRoles={['*']} path={'/change_password'} component={ChangePass}/>
                    <PrivateRoute exact validRoles={['*']} path={'/home'} component={Home}/>
                    <PrivateRoute exact validRoles={['*']} path={'/config'} component={Config} />

                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/list'} component={UserList}/>
                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/add'} component={NewUser}/>
                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/bulkInsert'} component={BulkInsert}/>
                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/edit'} component={EditUser}/>
                    <PrivateRoute exact validRoles={['ADMIN']} path={'/provider/view'} component={ViewUser}/>

                    <PrivateRoute exact validRoles={['ADMIN']} path={'/v1/admin/list'} component={AdminList}/>
                    <PrivateRoute exact validRoles={['ADMIN']} path={'/v1/admin/add'} component={NewAdmin}/>
                    <PrivateRoute exact validRoles={['ADMIN']} path={'/v1/admin/edit'} component={EditAdmin}/>

                    <PrivateRoute exact validRoles={['ADMIN']} path={'/affiliate/list'} component={AffiliatesList}/>
                    <PrivateRoute exact validRoles={['ADMIN']} path={'/affiliate/attentions'} component={AttentionList}/>
                    <PrivateRoute exact validRoles={['*']} path={'/affiliates'} component={Affiliates}/>

                    <PrivateRoute exact validRoles={['*']} path={'/v1/plans/list'} component={PlanList}/>
                    <PrivateRoute exact validRoles={['*']} path={'/plans/medicalServices'} component={MedicalServices}/>

                    <PrivateRoute exact validRoles={['*']} path={'/v1/newMedicalService'} component={MedicalService}/>
                    <PrivateRoute exact validRoles={['*']} path={'/v1/attentionsList'} component={AttentionsList}/>
                    <PrivateRoute exact validRoles={['*']} path={'/medicalServiceList'} component={MedicalServiceList}/>
                    <PrivateRoute exact validRoles={['*']} path={'/createAttention'} component={CreateAttention}/>
                    <PrivateRoute exact validRoles={['*']} path={'/amount/list'} component={AmountList}/>
                    <PrivateRoute exact validRoles={['ADMIN']} path={'/performance'} component={Performance}/>
                </div>*/}
            </Switch>
            </div>
        </LocationRouter>
    );
};


export default App;
